import React from "react";
import ChatPanel from "./chatPanel"; // <- apunta al archivo real
import AgentIcon from "./AgentIcon";

export default function ChatDockPanel({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay suave (click afuera cierra) */}
      <div
        className="fixed inset-0 bg-black/20 z-[45]"
        onClick={onClose}
      />

      {/* Ventana flotante, abajo a la derecha. Los botones flotantes de cada pantalla ("Nueva Consulta",
          "+ cita"...) quedaron en z-40, por debajo: así la ventana los tapa en vez de que se le monten
          encima del campo de escribir. Y por debajo de los modales (z-50), que la oscurecen. */}
      <div className="fixed bottom-5 right-5 z-[46] w-[420px] max-w-[92vw]">
        <div className="rounded-2xl overflow-hidden shadow-2xl border border-black/10 bg-white">
          {/* Header dock */}
          <div className="flex items-center justify-between px-4 py-3 bg-white border-b border-black/10">
            <div className="flex items-center gap-2">
              <AgentIcon className="w-8 h-8" />
              <div className="leading-tight">
                <div className="text-sm font-semibold text-gray-900">
                  Asistente
                </div>
                <div className="text-xs text-gray-500">En línea</div>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="w-9 h-9 rounded-full hover:bg-black/[0.06] flex items-center justify-center"
              aria-label="Cerrar"
              title="Cerrar"
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div className="p-3">
            <ChatPanel />
          </div>
        </div>
      </div>
    </>
  );
}
